<template>
  <div class="homepage-banners" style="">
    <div class="banner-img">
      <div v-if="banners.length > 1" id="banner" class="">
        <ol
          v-if="banners.length > 1"
          class="partner-bannerDot"
          v-show="isShowDot"
        >
          <li
            v-for="(item, i) in banners"
            :key="i"
            ref="bannerDot"
            class="bannerDot"
            :class="{ active: i == 0 }"
            @click="changeBanner(i)"
          ></li>
        </ol>
        <swiper :options="swiperOptions" class="time-wrap" ref="bannerSwiper">
          <swiper-slide
            v-for="(banner, index) in banners"
            :key="index"
            v-show="isSwiperShow"
          >
            <HomeCruiseBanner v-if="banner.cruiseInfo" :banner="banner" :index="index"/>
            <div v-else-if="banner.url && banner.url.length > 0">
              <a :href="banner.url" style="display: block; cursor: pointer" @click="gioTrack(index+1, banner.url)">
                <img :src="banner.image" width="100%" />
                  <div class="clock" v-if="isShowCountDown(banner)">
                  <span>
                    <img
                      src="https://resource.rcclchina.com.cn/homePage/clock.png"
                    />
                    活动倒计时
                  </span>
                  <CruiseCountDown
                    :countDownNum="getCountDown(banner)"
                    :className="timing"
                  />
                </div>
                <div v-else class="f-dn"></div>
              </a>
            </div>
            <div v-else>
              <img :src="banner.image" width="100%" />
              <div class="clock" v-if="isShowCountDown(banner)">
                <span>
                  <img
                    src="https://resource.rcclchina.com.cn/homePage/clock.png"
                  />
                  活动倒计时
                </span>
                <CruiseCountDown
                  :countDownNum="getCountDown(banner)"
                  :className="timing"
                />
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <a
          v-if="banners.length > 1"
          class="left carousel-control"
          @click="goPrev()"
        >
          <span class="banner-arrow-icon banner-arrow-left" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          v-if="banners.length > 1"
          class="right carousel-control"
          @click="goNext()"
        >
          <span class="banner-arrow-icon banner-arrow-right" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
      <div v-else-if="banners.length == 1">
        <a
          v-if="banners[0].url && banners[0].url.length > 0"
          :href="banners[0].url"
          style="display: block; cursor: pointer"
        >
          <img :src="banners[0].image" width="100%" />
        </a>
        <img v-else :src="banners[0].image" width="100%" />
      </div>
      <div v-else class="f-dn"></div>
    </div>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import { gioAdsTracking } from "@/utilities/tools";
const { Swiper, SwiperSlide } = VueAwesomeSwiper;
const CruiseCountDown = () => import("@/components/Home/CruiseCountDown");
const HomeCruiseBanner = () => import("@/components/Home/HomeCruiseBanner");
export default {
  name: "HomeBanner",
  components: {
    CruiseCountDown,
    HomeCruiseBanner,
    Swiper,
    SwiperSlide,
  },
  props: {
    banners: {
      type: Array,
      default() {
        return [];
        // {
        //     'image': 'required',
        //     'url': 'optional',
        //     'promoEndTime': 'optional',
        //     'showCountDown': false

        // }
      },
    },
    isShowDot: {
      type: Boolean,
      default() {
        return false;
      },
    },
    autoplay: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    let autoplay = false;
    if (this.autoplay) {
      autoplay = {
        delay: 5000,
      };
    }
    return {
      swiperOptions: {
        loop: true,
        speed: 500,
        autoplay: autoplay,
        on: {
          slideChangeTransitionEnd: this.onBannerSliderChange,
          init: this.showSwiper,
        },
      },
      isSwiperShow: false,
      swiper: null,
    };
  },
  mounted() {
    if (this.banners.length <= 1) {
      this.swiperOptions.loop = false;
    }
    this.$nextTick(() => {
      this.onBannerInit();
    });
  },
  methods: {
    isShowCountDown(item) {
      let now = new Date();
      const endTime = item.promoEndTime;
      let checkEndTime = 0;
      if (endTime && endTime.length > 0) {
        checkEndTime = new Date(endTime.replace("T", " ")).getTime();
        let result = item.showCountDown && checkEndTime > now.getTime();
        return result;
      }
      return false;
    },
    getCountDown(item) {
      const endTime = item.promoEndTime;
      let checkEndTime = 0;
      if (endTime && endTime.length > 0) {
        checkEndTime = new Date(endTime.replace("T", " ")).getTime();
      }
      return checkEndTime;
    },
    goPrev() {
      if (!this.swiper && this.$refs.bannerSwiper) {
        this.swiper = this.$refs.bannerSwiper.$swiper;
      }
      this.swiper.slidePrev();
    },
    goNext() {
      if (!this.swiper && this.$refs.bannerSwiper) {
        this.swiper = this.$refs.bannerSwiper.$swiper;
      }
      this.swiper.slideNext();
    },
    onBannerInit() {
      if (this.$refs.bannerSwiper) {
        this.swiper = this.$refs.bannerSwiper.$swiper;
        if (this.autoplay && this.banners.length > 0) {
          this.swiper.autoplay.stop();
          this.swiper.autoplay.start();
        }
      }
    },
    onBannerSliderChange() {
      if (!this.swiper && this.$refs.bannerSwiper) {
        this.swiper = this.$refs.bannerSwiper.$swiper;
      }

      if (this.swiper) {
        const index = this.swiper.realIndex;
        if (this.isShowDot) {
          const dots = this.$refs.bannerDot;
          dots.forEach((dot) => {
            dot.classList.remove("active");
          });
          dots[index].className += " active";
        }
        // document.getElementById('cruiseDetailBannerIndex').innerHTML = this.swiper.realIndex + 1

        this.$emit("onBannerSliderChange", index);
      }
    },
    changeBanner(index) {
      if (this.swiper) {
        this.swiper.slideTo(index + 1);
      }
    },
    showSwiper() {
      this.isSwiperShow = true;
    },
		gioTrack(index, url) {
			const eventObject = {
				"adsType": "bn",
				"bnOrder": index,
				"desUrl": url
			}
			gioAdsTracking(eventObject);
		}
  },
  computed: {
    timing() {
      return "timing";
    },
  },
  watch: {
    banners(newValue) {
      if (newValue.length <= 1) {
        this.swiperOptions.loop = false;
      } else {
        this.swiperOptions.loop = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.homepage-banners {
  position: relative;
  min-width: 1200px;
  /* height: 648px; */
}

// .homePage .homepage-banners{
//     // height: 648px;
// }

.homepage-banners .time-wrap {
  width: 100%;
}

.homepage-banners .carousel-inner {
  height: 100%;
}

.homepage-banners .carousel-inner .item {
  height: 100%;
}

.homepage-banners .banner-img {
  height: 100%;
  /* height: 648px;
    overflow: hidden; */
}

.homepage-banners .img.cruise-banner-image {
  width: initial;
  max-width: none;
  position: relative;
}

.homepage-banners .clock {
  width: 224px;
  height: 64px;
  position: absolute;
  left: 110px;
  bottom: 65px;
  border-radius: 34px;
  background: rgba(248, 0, 41, 0.8);
  display: block;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  box-sizing: border-box;
  text-align: center;
  padding-top: 3px;
}

// .homepage-banners .swiper-slide {
//     height: auto;
// }

// .homepage-banners .swiper-slide>div {
//     height: 100%;
// }

.homepage-banners .clock .count-down-wrapper.timing {
  display: block;
}

.homepage-banners .clock .count-down-wrapper span:first-child {
  font-size: 18px;
}
.homepage-banners .clock .count-down-wrapper span:nth-child(2) {
  font-size: 14px;
}
.homepage-banners .clock .count-down-wrapper span span {
  position: relative;
  top: -2px;
}
.homepage-banners .clock .count-down-wrapper.timing span.num {
  color: #ffa70d;
  font-size: 24px;
  font-weight: 400;
}
.homepage-banners .saleArea {
  width: 696px;
  height: 284px;
  position: absolute;
  left: 20%;
  top: 20%;
  background: rgba(0, 0, 0, 0.6);
}

.homepage-banners .saleArea .tagbg {
  width: 158px;
  height: 24px;
  position: absolute;
  left: -5px;
  top: 10px;
  background: url("https://resource.rcclchina.com.cn/homePage/homePage-linebg.png")
    no-repeat 100%;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 24px;
}
.homepage-banners .saleArea .big-title {
  font-size: 48px;
  font-weight: bold;
  color: #fff;
  margin-left: 30px;
  margin-bottom: 29px;
  position: relative;
  top: 27px;
}
.homepage-banners .saleArea .text {
  font-size: 16px;
  color: #fff;
  margin-left: 30px;
  margin-bottom: 10px;
  font-weight: 400;
}
.homepage-banners .saleArea .txt1 > span {
  display: inline-block;
  width: 80px;
  height: 22px;
  border-radius: 20px;
  background: #ffa70d;
  font-size: 12px;
  color: #333;
  line-height: 22px;
  margin-left: 2px;
}
.homepage-banners .saleArea .txt1 > span img {
  margin-left: 12px;
  margin-right: 3px;
  position: relative;
  top: -1px;
}
.homepage-banners .saleArea .txt2 {
  margin-bottom: 15px;
}
.homepage-banners .saleArea .line {
  width: 60px;
  height: 1px;
  margin-left: 30px;
  margin-bottom: 16px;
  background: #fbc500;
}
.homepage-banners .saleArea .price {
  /* width: 402px; */
  display: block;
  justify-content: space-between;
  margin-left: 30px;
}
.homepage-banners .saleArea .price .tiny {
  display: inline-block;
  vertical-align: top;
}
.homepage-banners .saleArea .price .tiny span:first-child {
  color: #fff;
  font-size: 16px;
}
.homepage-banners .saleArea .price .tiny span:last-child {
  color: #fbc500;
  font-size: 16px;
  display: block;
}
.homepage-banners .saleArea .price .tiny span:last-child > i {
  font-style: normal;
  font-size: 30px;
  font-weight: bold;
}
.homepage-banners .saleArea .price .p-btn {
  // display: block;
  width: 188px;
  height: 52px;
  line-height: 52px;
  text-align: center;
  font-size: 22px;
  font-weight: 500;
  color: #282b2c;
  background: #fbc500;
  display: inline-block;
  vertical-align: top;
  margin-left: 15px;
}
.homepage-banners .saleArea .price .p-btn:hover {
  background: #f8de57;
}
.homepage-banners .banner-img a.carousel-control {
  width: 10%;
  opacity: 1;
  background: none;
}

.homepage-banners .carousel-control .banner-arrow-icon {
  position: absolute;
  top: 50%;
  z-index: 0;
  display: block;
  width: 44px;
  height: 44px;
  margin-top: -22px;
}

.homepage-banners .carousel-control .banner-arrow-icon::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 22px;
  height: 22px;
  border: solid #fff;
  border-width: 0 4px 4px 0;
}

.homepage-banners .carousel-control .banner-arrow-left {
  left: 50%;
  margin-left: -22px;
}

.homepage-banners .carousel-control .banner-arrow-left::before {
  transform: translate(-50%, -50%) rotate(135deg);
}

.homepage-banners .carousel-control .banner-arrow-right {
  right: 50%;
  margin-right: -22px;
}

.homepage-banners .carousel-control .banner-arrow-right::before {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.partner-bannerDot {
  position: absolute;
  bottom: 10px;
  left: 0;
  z-index: 15;
  width: 100%;
  padding-left: 0;
  margin-left: 0;
  text-align: center;
  list-style: none;
}

.partner-bannerDot-up {
  bottom: 3px;
}

.partner-bannerDot .bannerDot {
  display: inline-block;
  vertical-align: middle;
  width: 30px;
  height: 5px;
  cursor: pointer;

  border-radius: 2px;
  background-color: rgb(211, 218, 221);
  opacity: 0.702;
  margin: 1px;
}

.partner-bannerDot .bannerDot:first-child {
  margin-right: 5px;
}

.partner-bannerDot .bannerDot.active {
  width: 55px;
  background-color: #ffcd00;
}

#banner {
  width: 100%;
  position: relative;
  .carousel-control {
    z-index: 1;
  }
}
</style>
